import React from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { getEmailTypeList } from 'app/components/MarginTool/Components/PayPackage/PayPackageHelper';

export const PlacementPayPackagesEmailCell = ({
  disabled,
  onSelectVariant,
}: {
  disabled?: boolean;
  onSelectVariant: (variant: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e?: any) => {
    if (e?.preventDefault) e.preventDefault();
    if (e?.stopPropagation) e.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{ cursor: 'pointer' }}
        disabled={disabled}
        aria-label="email-actions"
      >
        <MailOutlineIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disablePortal={false}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '10px',
              minWidth: 200,
              overflow: 'hidden',
              zIndex: 2000,
            },
          },
        }}
        MenuListProps={{
          dense: true,
          onClick: e => {
            e.stopPropagation();
          },
        }}
      >
        {getEmailTypeList().map(emailType => (
          <MenuItem
            key={emailType.id}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleClose(e);
              onSelectVariant(emailType.type);
            }}
            disabled={disabled}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <MailOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={emailType.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
